import React from 'react';

import { DAYS, MONTHS, YEARS } from '../../utils/dates';
import { DropdownField } from '../FormFields';

interface DateOfBirthFieldProps {
  disableDobInput: boolean;
  error?: string;
}

const DateOfBirthField = ({ error, disableDobInput }: DateOfBirthFieldProps) => {
  return (
    <>
      <div className="dob-container tw-mt-24 tw-mb-12 tw-flex tw-items-center">
        <div className="tw-text-primary-red tw-text-body-sm tw-uppercase tw-font-bold tw-font-sans">
          Birthday
        </div>
        <div className="tw-ml-12 tw-flex-1 tw-bg-primary-red tw-h-2"></div>
      </div>
      <div className="tw-flex tw-items-center tw-space-x-6">
        <div className="tw-w-5/12">
          <DropdownField
            name="month"
            options={MONTHS}
            placeholder="Month"
            isDisabled={disableDobInput}
          />
        </div>
        <div className="tw-w-3/12">
          <DropdownField name="day" options={DAYS} placeholder="Day" isDisabled={disableDobInput} />
        </div>
        <div className="tw-w-4/12">
          <DropdownField
            name="year"
            options={YEARS}
            placeholder="Year"
            isDisabled={disableDobInput}
          />
        </div>
      </div>
      {error && <div className="tw-text-primary-red tw-text-body-sm tw-mt-6">{error}</div>}
    </>
  );
};

export default DateOfBirthField;
